import React from "react";
import PhotosMascota from "./photosMascota";
import {TypesHightPhoto} from "../constants/constants";
import { connect } from "react-redux";
import { validateThereUrl, isThereUrl } from "../mascotas/util-functions";
import PhotosMascotaHeader from "./photosMascotaHeader";
const mapState = (state) => {
	return {
        "poliza": state.polizas.poliza,
		"ramo": state.polizas.ramoActual,
	};
};
const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		}
	};
};
class PhotosMascotaCmpt extends React.Component {
    render () {
        return  <div className="card card_photos">
             <PhotosMascotaHeader title="Fotografías" imgUrl={require("../img/imageIcon.svg")} />
        <div className="row card_content-photos">
            {
                this.props.poliza.links_mascota && this.props.poliza.links_mascota.map( (mascotaPhoto, index) => 
                    <div className="col-md-6 col-sm-12 card_content_preview-photos" key={index}>
                       <PhotosMascota url={validateThereUrl(mascotaPhoto.url)} 
                            footerTitle={`Vista ${mascotaPhoto.nombre}`} 
                            hight={isThereUrl(mascotaPhoto.url) ? TypesHightPhoto.mascota : TypesHightPhoto. noImageMascota }
                            withFooter={isThereUrl(mascotaPhoto.url) !== ""}
                       />
                    </div>
                    )
            }
        </div>
    </div>
    }
}
export default connect(mapState, mapDispatch) (PhotosMascotaCmpt); 



// WEBPACK FOOTER //
// ./src/home/photosMascota.cmpt.js